import { useQuery } from '@apollo/client';

import GET_COURSE_RESTRICTIONS_QUERY from './graphql/get-course-restrictions.v5.graphql';
import type {
  GetCourseRestrictionsQuery,
  GetCourseRestrictionsQueryVariables,
} from './graphql/types/GetCourseRestrictionsQuery';
import type {
  TRestrictedCode,
  TUseCourseRestrictionDataReturn,
  TUseCourseRestrictionParams,
} from './types';

export function useCourseRestriction(
  params: TUseCourseRestrictionParams,
): TUseCourseRestrictionDataReturn {
  const shouldSkip =
    !params?.courseId || !params?.organizationId || params?.skip;
  const { data, loading, error, called } = useQuery<
    GetCourseRestrictionsQuery,
    GetCourseRestrictionsQueryVariables
  >(GET_COURSE_RESTRICTIONS_QUERY, {
    variables: {
      input: {
        course_id: params.courseId ?? '',
        organization_id: params.organizationId ?? 0,
      },
    },
    skip: shouldSkip,
    context: {
      clientName: 'v5',
    },
  });

  const courseRestrictionData = data?.course.get_course_restriction;
  const courseRestricted =
    courseRestrictionData?.__typename === 'CourseRestrictionPayload';
  const restrictedCode =
    courseRestrictionData?.__typename === 'CourseRestrictionPayload'
      ? (courseRestrictionData.restriction_code as TRestrictedCode)
      : undefined;

  return {
    called,
    isLoading: loading,
    isError: !!error,
    data: courseRestrictionData,
    courseRestricted,
    restrictedReason: courseRestricted
      ? courseRestrictionData.restriction_message
      : undefined,
    restrictedCode,
  };
}
